<template>
  <div class="flowCenter">
    <div class="box">
      <div class="container clear">
        <div class="main-left fl">
            <sidebar-page></sidebar-page>
        </div>
        <div class="main-right fl">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane class="flow tab" label="   流量任务   " name="tbTask"></el-tab-pane>
            <el-tab-pane class="collection tab" label="收藏任务" name="tbCollection"></el-tab-pane>
            <el-tab-pane class="add tab" label="加购任务" name="tbAdd"></el-tab-pane>
            <el-tab-pane class="wangwang tab" label="旺旺打标" name="wangwang">

              <el-form label-width="84px" :model="formList" label-position="right">
                  <el-form-item label="宝贝链接" prop="link">
                      <el-input placeholder="请输入宝贝链接" v-model="formList.goodsUrl" @input="changeLink"></el-input>
                  </el-form-item>
                  <el-form-item label="宝贝标题" prop="link">
                      <el-input class="input-with-select" placeholder="标题自动获取或手动填写" v-model="formList.goodsTitle"></el-input>
                      <div class="taotask_time taotask-item" v-for="(item,keys) in keyForm" :key="keys">
                          <span class="taotaskAdd" @click="addkey(keys)">+</span ><span class="taotaskReduce" @click="delkey">-</span>
                          <el-form-item :label="'关键词'+(keys+1)">
                              <el-input  class="input-with-select" v-model="item.keyWord" @input="getKey(item.keyWord, keys)" placeholder="关键词必须为标题内含有文字，且区分大小写"></el-input>
                          </el-form-item>
                          <el-row>
                              <el-col :span="24">
                                  <el-form-item label="旺旺号">
                                      <el-input
                                        type="textarea"
                                        :rows="2"
                                        placeholder="请输入旺旺号，多个旺旺号以逗号隔开"
                                        v-model="item.account">
                                      </el-input>
                                  </el-form-item>
                              </el-col>
                          </el-row>
                      </div>
                  </el-form-item>
                  <el-form-item>
                      <div v-show="busType">
                        <el-button class="btn-search mt20" type="primary" :loading="loading" @click="wangwangMarking">
                              <span v-if="!loading">打 标</span>
                              <span v-else>正在打标...</span>
                          </el-button>
                      </div>
                  </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sidebarPage from '../../components/sidebar'
import $ from 'jquery'
import http from '../../axios'
import { getIdFromUrl } from '@/utils'
export default {
  inject: ['reload'],
  components: {
    sidebarPage
  },
  data () {
    return {
      loading: false,
      activeName: 'wangwang',
      busType: true,
      keyForm: [{
        keyWord: '', // 关键词
        account: '' // 旺旺号
      }],
      formList: {
        platformType: '', // 平台类型
        flowType: '', // 流量类型
        goodsTitle: '', // 商品标题
        goodsUrl: '' // 商品链接
      },
      badyLinkID: '' // 商品ID
    }
  },
  methods: {
    wangwangMarking () {
      const _this = this
      // 深拷贝一组keyForm
      let arr = _this.keyForm.map(o => ({...o}))
      arr.forEach((item, index) => {
        item.account = item.account
      })
      let arrayList = []
      _this.keyForm.forEach((item, index) => {
        if (item.account === '' || item.account === undefined) {
          // console.log(item.account.length)
        } else {
          let a = item.account.split('，')// 字符串转数组
          arrayList.push(a.length)
        }
      })
      var sum = arrayList.reduce(function (a, b) {
        return a + b
      }, 0)
      if (_this.formList.goodsUrl === '') {
        _this.$message({
          message: '请输入宝贝链接',
          type: 'warning'
        })
      }
      if (_this.formList.goodsUrl.goodsTitle) {
        _this.$message({
          message: '宝贝标题不能为空',
          type: 'warning'
        })
      }
      let kw = true
      // 判断关键字是否正确
      for (let index = 0; index < _this.keyForm.length; index++) {
        if (_this.keyForm[index].keyWord === '') {
          _this.$message({
            type: 'warning',
            message: '关键词' + (index + 1) + '不能为空'
          })
          return
        }
        if (_this.keyForm[index].account === '') {
          _this.$message({
            type: 'warning',
            message: '旺旺号不能为空'
          })
          return
        }
        let arrkey = []
        let keywordNew = _this.keyForm[index].keyWord.replace(/\s+/g, '')
        arrkey = keywordNew.split('')// 字符串转数组
        let errorKeyWord = []
        arrkey.forEach((item2, index2) => {
          if (_this.formList.goodsTitle.indexOf(item2) === -1) {
            errorKeyWord.push(item2)
          }
        })
        if (errorKeyWord.length > 0) {
          _this.$message({
            type: 'error',
            message: "关键词'" + errorKeyWord + "'不存在标题中"
          })
          return
        } else {
          kw = false
        }
      }
      if (kw) {
        return
      }
      _this.loading = true
      let params = {
        id: _this.badyLinkID,
        keyList: arr,
        module: '8',
        money: sum,
        platform: '1',
        url: _this.formList.goodsUrl,
        title: _this.formList.goodsTitle
      }
      try {
        http.wangwang(params).then(({ data }) => {
          _this.loading = false
          switch (data.code) {
            case 0:
              _this.$message({
                message: '打标成功',
                type: 'success'
              })
              _this.reload()
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    },
    handleClick (tab, event) {
      this.$router.push({path: '/'+tab.name})
    },
    addkey (keys) { // 添加关键词
      let _this = this
      _this.keyForm.push({
        keyWord: '',
        account: ''
      })
    },
    delkey () { // 删除关键词
      let _this = this
      let num = _this.keyForm.length - 1
      if (num > 0) {
        _this.keyForm.splice(num, 1)
      } else {
        _this.$message({
          message: '关键词至少要有一个',
          type: 'warning'
        })
      }
      _this.countAll()
    },
    // key值不能为空
    getKey (val, keys) {
      let _this = this
      if (val === '') {
        _this.$message({
          type: 'warning',
          message: '请输入关键字'
        })
        return false
      } else {
        // 判断关键字是否正确
        for (let index = 0; index < _this.keyForm.length; index++) {
          if (_this.keyForm[keys].keyWord === '') {
            _this.$message({
              type: 'warning',
              message: '关键词' + (keys + 1) + '不能为空'
            })
            return
          }
          let arrkey = []
          let keywordNew = _this.keyForm[keys].keyWord.replace(/\s+/g, '')
          arrkey = keywordNew.split('')// 字符串转数组
          let errorKeyWord = []
          arrkey.forEach((item2, index2) => {
            if (_this.formList.goodsTitle.indexOf(item2) === -1) {
              errorKeyWord.push(item2)
            }
          })
          if (errorKeyWord.length > 0) {
            if (_this.keyForm[keys].keyWord !== '') {
              _this.$message({
                type: 'error',
                message: "关键词'" + errorKeyWord + "'不存在标题中"
              })
              return
            }
          }
        }
      }
    },
    changeLink () {
      let _this = this
      var badyLinkID
      this.formList.goodsTitle = ''
      if (!localStorage.getItem('token')) {
        _this.$router.push({path: '/login'})
        return
      }
      if (this.formList.goodsUrl.startsWith('http') && this.formList.goodsUrl.indexOf('id=') !== -1) {
        badyLinkID = getIdFromUrl(this.formList.goodsUrl)
      } else {
        this.$message.info('请输入正确的宝贝链接或ID')
        this.loading = false
        return
      }
      _this.ajaxTB(badyLinkID)
    },
    ajaxTB (badyLinkID) {
      let _this = this
      _this.badyLinkID = badyLinkID
      let params = {
        url: this.formList.goodsUrl
      }
      try {
        http.newGetgoodsTitle(params).then(({ data }) => {
          _this.loading = false
          switch (data.code) {
            case 0:
              _this.formList.goodsTitle = data.data.title
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }

    }
  },
  mounted () {
    let _this = this
    // 获取从其他页面跳过来的信息
    if (_this.$route.params.busininfo !== undefined) {
      let info = JSON.parse(this.$route.params.busininfo)
      _this.keyForm = info.keyList
      _this.formList.goodsUrl = info.url
      _this.formList.goodsTitle = info.title
    }
    if (!localStorage.getItem('info')) {
      this.$message({
        type: 'warning',
        message: '请登录后使用'
      })
      this.$router.push({path: '/login'})
    }
  }
}
</script>
<style lang="less" scoped>
.btn_li {
    float: left;
    display: block;
    line-height: 1;
    white-space: nowrap;
    background: #fff;
    border: 1px solid #dcdfe6;
    font-weight: 500;
    border-left: 0;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    cursor: pointer;
    -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
    transition: all .3s cubic-bezier(.645,.045,.355,1);
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 0;
}
.container {
    background:rgba(255,255,255,1);
    border:1px solid rgba(238,238,238,1);
    border-radius:5px;
    width: 1200px;
    margin: auto;
    margin-top: 15px;
    margin-bottom: 15px;
    .main-left {
        width: 15%;
    }
    .main-right {
        width: 85%;
        padding: 15px 56px 27px;
        box-sizing: border-box;
        /deep/ .el-tabs__item {
            width: 103px !important;
            padding: 0;
            text-align: center;
            font-size: 18px;
            color: #333333;
        }
        /deep/ .el-tabs__item.is-active,
        /deep/ .el-tabs__item:hover {
            color: #FC6B0E;
        }
        /deep/ .el-tabs__active-bar {
            background: #FC6B0E;
        }
        .commonTabnav {
            ul {
                font-size: 0;
                border-left: 1px solid #dcdfe6;
                border-radius: 3px;
                overflow: hidden;
                li {
                    .btn_li();
                }
                li:first-child {
                    border-radius: 3px 0 0 3px;
                }
                li:last-child {
                    border-radius: 0 3px 3px 0;
                }
                .active {
                    background-color: #fc6b0e;
                    border-color: #fc6b0e;
                    color: #fff;
                }
            }
        }
        /deep/ .el-form-item__content {
            margin-left: 102px !important;
        }
        .taotask_time {
            border: 2px solid #fc6b0e;
            background-color: #fef0e7;
            margin: 15px 0;
            padding-right: 20px;
            position: relative;
            padding-top: 10px;
            .taotaskAdd, .taotaskReduce{
                position: absolute;
                width: 40px;
                height: 40px;
                left: -50px;
                text-align: center;
                line-height: 38px;
                font-size: 23px;
                border: 1px solid #fc6b0e;
                border-radius: 50%;
                cursor: pointer;
            }
            .taotaskAdd {
                background-color: #fc6b0e;
                color: #fff;
                top: 0;
            }
            .taotaskReduce {
                top: 50px;
                color: #fc6b0e;
            }
            .likeInput {
                -webkit-appearance: none;
                background-color: #fff;
                background-image: none;
                border-radius: 4px;
                border: 1px solid #d4d4d4;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                color: #606266;
                font-size: inherit;
                height: 40px;
                line-height: 40px;
                outline: 0;
                padding: 0 15px;
                -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                width: 100%;
            }
            /deep/ .el-form-item {
                margin-bottom: 22px;
            }
            .taoQs {
                text-align: right;
                line-height: 20px;
                font-size: 12px;
                color: #999;
                .taoQs_box {
                    position: relative;
                    display: inline-block;
                    margin-left: 10px;
                    .taoQs_boxText {
                        position: absolute;
                        right: 0;
                        background: #fff;
                        min-width: 150px;
                        width: 250px;
                        border-radius: 4px;
                        border: 1px solid #ebeef5;
                        padding: 12px;
                        z-index: 2000;
                        color: #606266;
                        line-height: 1.4;
                        text-align: justify;
                        font-size: 14px;
                        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                        word-break: break-all;
                        top: 100%;
                        display: none;
                        h5 {
                            font-size: 15px;
                            margin-bottom: 12px;
                        }
                        p {
                            font-size: 13px;
                            line-height: 23px;
                        }
                    }
                    .taoQs_span{
                        display: block;
                        border-bottom: 1px solid #ffc49e;
                        cursor: pointer;
                        &:hover{
                            color:#fc6b0e;
                        }
                    }
                    &:hover .taoQs_boxText{
                        display: block;
                    }
                }
            }
            .dialogTbaoText{
                line-height: 24px;
            }
            .tasktimeBox input::-webkit-outer-spin-button,.tasktimeBox input::-webkit-inner-spin-button{
                -webkit-appearance: none !important;
                margin: 0;
            }
            .el-date-editor .el-input__suffix{
                display: none;
            }
            body .el-checkbox__input.is-checked+.el-checkbox__label {
                color: #fc6b0e;
            }
            .tasktimeBox_fa {
                padding: 0 0 0 34px;
                .tit {
                    color: #666;
                    font-size: 12px;
                }
                .tasktimeBox {
                    display: inline-block;
                    margin-right: 2px;
                    border-radius: 10px;
                    overflow: hidden;
                    text-align: center;
                    width: 40px;
                    border: 1px solid #fc6b0e;
                    p {
                        line-height: 22px;
                    }
                    .bg {
                        background-color: #fc6b0e;
                        color: #fff;
                    }
                    input {
                        margin: 0;
                        width: 100%;
                        border: 0;
                        background-color: transparent;
                        text-align: center;
                        display: block;
                        line-height: 24px;
                        color: #fc6b0e;
                    }

                }
            }

        }
        .likeInput {
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            border-radius: 4px;
            border: 1px solid #d4d4d4;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            color: #606266;
            font-size: inherit;
            height: 40px;
            line-height: 40px;
            outline: 0;
            padding: 0 15px;
            -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
            transition: border-color .2s cubic-bezier(.645,.045,.355,1);
            width: 100%;
        }
        .mini {
            width: 200px;
            display: inline-block;
        }
        .in-block {
          float: right;
          .commButton {
            display: inline-block;
            text-align: center;
            border-radius: 3px;
            min-width: 76px;
            height: 35px;
            padding: 0 15px;
            line-height: 35px;
            color: #fc6b0e;
            border: 1px solid #fc6b0e;
            margin-left: 10px;
            cursor: pointer;
          }
          .active {
            background-color: #fc6b0e;
            color: #fff;
          }
        }
        /deep/ .el-checkbox__label {
            color: #fc6b0e;
        }
        /deep/ .is-checked{
            /deep/ .el-checkbox__inner {
                border-color: #fc6b0e;
                background: #fc6b0e;
            }

        }
        /deep/ .el-button:focus {
            color: #fc6b0e;
            border-color: #f9d7c1;
            background-color: #fff6f1;
        }
        /deep/ .el-button:hover {
            color: #fc6b0e;
            border-color: #f9d7c1;
            background-color: #fff6f1;
        }
        /deep/ .el-button--primary {
            background-color: #fc6b0e;
            border-color: #fc6b0e;
        }
        /deep/ .el-button--primary:hover{
            background-color: #fd863a;
            border-color: #fd863a;
            color: #fff;
        }
        .commTs {
            font-size: 12px;
            color: #666;
            span {
                color: #ff1e00;
                font-size: 14px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/wangwang/wangwang.vue